"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CurrentLocationButton = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _SearchConfigurationProvider = require("../../../containers/SearchConfigurationProvider");
var _contexts = require("../../../contexts");
var _hooks = require("../../../hooks");
var _models = require("../../../models");
var _jsxRuntime = require("react/jsx-runtime");
const CurrentLocationButton = ()=>{
    const { formatMessage } = (0, _hooks.useTranslations)();
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { currentLocation, isCurrentLocationAllowed } = (0, _contexts.useMap)();
    const { setViewSettings, zoomAfterSelection } = (0, _SearchConfigurationProvider.useSearchConfiguration)();
    const onClick = (0, _react.useCallback)(()=>{
        if (!currentLocation) {
            return;
        }
        setViewSettings({
            location: currentLocation,
            zoom: zoomAfterSelection
        });
    }, [
        currentLocation,
        zoomAfterSelection,
        setViewSettings
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Tooltip, {
        disableFocusListener: true,
        title: isCurrentLocationAllowed ? null : formatMessage('locationDisabledTooltip'),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            role: "button",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.IconButton, {
                color: "default",
                size: "large",
                variant: "contained",
                disabled: !isCurrentLocationAllowed,
                onClick: onClick,
                ...getTestIdProps(_models.TestId.SelectPickupPointDialogCurrentLocationButton),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.MapSelector, {})
            })
        })
    });
};
exports.CurrentLocationButton = CurrentLocationButton;
